function handleLeatherVisibility() {
  var genuineLeatherRadio = document.querySelector('input[type="radio"][value="Genuine Leather"]');
  var styleColorContainer = document.querySelector('.style-colorleather');

  if (!styleColorContainer) return;

  var hardwareGroup = styleColorContainer.querySelector('.hardware-radio-group');
  if (!hardwareGroup) return;

  var allInputs = hardwareGroup.querySelectorAll('input[type="radio"]');
  if (!allInputs.length) return;

  var isGenuineLeather = genuineLeatherRadio && genuineLeatherRadio.checked;

  // Server-rendered markup (before the API-built version replaces it): one swatch group per style.
  if (!styleColorContainer.querySelector('#style-swatch-group')) {
    var leatherRadio = hardwareGroup.querySelector('input[type="radio"][value="leather"]');
    var checkedInput = hardwareGroup.querySelector('input[type="radio"]:checked');
    var target = null;

    allInputs.forEach(function(input) {
      var label = hardwareGroup.querySelector('label[for="' + input.id + '"]');
      var hide = isGenuineLeather ? input.value !== 'leather' : input.value === 'leather';
      input.style.display = hide ? 'none' : '';
      if (label) label.style.display = hide ? 'none' : '';
    });

    if (isGenuineLeather) {
      target = leatherRadio;
    } else if (checkedInput && checkedInput.value !== 'leather') {
      target = checkedInput;
    } else {
      target = hardwareGroup.querySelector('input[type="radio"]:not([value="leather"])');
    }

    if (target) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  // API-built markup: one swatch list (#style-swatch-group) filtered by the checked style radio.
  // This runs on every variant change, so it must keep the shopper's style choice and the
  // style filter intact instead of re-showing every swatch.
  allInputs.forEach(function(input) {
    var label = hardwareGroup.querySelector('label[for="' + input.id + '"]');
    var hide = isGenuineLeather ? input.value !== 'leather' : input.value === 'leather';
    input.style.display = hide ? 'none' : '';
    if (label) label.style.display = hide ? 'none' : '';
  });

  var checked = hardwareGroup.querySelector('input[type="radio"]:checked');
  var checkedValid = checked && (isGenuineLeather ? checked.value === 'leather' : checked.value !== 'leather');
  if (!checkedValid) {
    var next = isGenuineLeather
      ? hardwareGroup.querySelector('input[type="radio"][value="leather"]')
      : hardwareGroup.querySelector('input[type="radio"]:not([value="leather"])');
    if (next) {
      next.checked = true;
      checked = next;
    }
  }

  var swatchGroup = styleColorContainer.querySelector('#style-swatch-group');
  if (!swatchGroup) return;

  var allSwatches = swatchGroup.querySelectorAll('.swatch-option');
  if (!allSwatches.length) return;

  var activeStyle = checked ? checked.value : '';
  allSwatches.forEach(function(swatch) {
    var styles = (swatch.getAttribute('data-style') || '').split(' ');
    swatch.style.display = styles.indexOf(activeStyle) !== -1 ? 'block' : 'none';
  });

  var selectedVisible = swatchGroup.querySelector('.swatch-option.selected');
  if (!selectedVisible || selectedVisible.style.display === 'none') {
    var firstVisible = Array.prototype.find.call(allSwatches, function(swatch) {
      return swatch.style.display !== 'none';
    });
    if (firstVisible) firstVisible.click();
  }
}

function bindLeatherVisibility() {
  var upholsteryRadios = document.querySelectorAll('input[type="radio"][name^="Upholstery Type"]');
  upholsteryRadios.forEach(function(radio) {
    radio.removeEventListener('change', handleLeatherVisibility);
    radio.addEventListener('change', handleLeatherVisibility);
  });
  handleLeatherVisibility();
}

// page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindLeatherVisibility);
} else {
  bindLeatherVisibility();
}

// ajax ke baad
document.addEventListener('click', function(e) {
  var upholsteryLabel = e.target.closest('label[for^="template--"]');
  if (!upholsteryLabel) return;
  var forAttr = upholsteryLabel.getAttribute('for');
  var radio = document.getElementById(forAttr);
  if (!radio || radio.name.indexOf('Upholstery Type') === -1) return;
  setTimeout(function() {
    bindLeatherVisibility();
  }, 300);
});

// shopify ajax complete
document.addEventListener('shopify:section:load', bindLeatherVisibility);

// variant change event
document.addEventListener('variantChange', bindLeatherVisibility);
document.addEventListener('variant:changed', bindLeatherVisibility);
//Product price content
const getProductPrice1 = document.querySelector('.product__info-wrapper span.price-item.price-item--regular');

//custom code start
function updateSelectedData() {
 

    const selectBox = document.querySelector('variant-selects');
    if (!selectBox) return;

    selectBox.querySelectorAll('fieldset').forEach(fieldset => {
        const input = fieldset.querySelector('input:checked');
        if (!input) return;

        const handle = input.value
            .trim()
            .toLowerCase()
            .replace(/\s*\/\s*/g, '-')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9\-]/g, '');

      

        const target = document.querySelector(`.cstm-${handle}`);
        if (target) {
            target.classList.add('active');
        }
    });


  const imageswatches = document.querySelectorAll('.swatch-option.selected');
imageswatches.forEach(el => {
    if (el.offsetParent !== null) {
        try { el.click(); } catch (err) { console.error('Swatch click failed', err); }
    }
});
 
  if (typeof window.initCustomSwatchGroups === 'function') window.initCustomSwatchGroups();
  if (typeof handleLeatherVisibility === 'function') handleLeatherVisibility();

     setTimeout(function(){
      getLineItemInput();
     
      initTempleUpholstery()
     
       },700);
 
  
}

function slugify(str) {
    return str.toLowerCase()
        .replace(/\s*\/\s*/g, '-')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '')
        .replace(/-+$/g, '');
}

var container = document.querySelector('.cstm-variant');

function activateHardwareGroup(input) {
   
    if (!input || !input.value) return;

    const val = slugify(input.value);
    const allHardwareGroups = document.querySelectorAll('[data-hardware-group]');

    allHardwareGroups.forEach(group => {
        const groupKey = group.dataset.hardwareGroup || '';
        group.classList.toggle('active', groupKey === 'hardware-' + val);
    });
}



function getLineItemInput() {

    const productForm = document.querySelector('.product-form form[action="/cart/add"]');
    if (!productForm) return;

    document.querySelectorAll('.custom-swatch-group.active').forEach(group => {
        const style = window.getComputedStyle(group);
       
         if (group.offsetParent === null) return;
        const selected = group.querySelector('.swatch-option.selected');
        if (!selected) return;

        const label = selected.getAttribute('label-line-item') || '';
        const value = group.querySelector('.swatch-selected')?.textContent.trim() || '';
        
     if (
    label &&
    value &&
    !label.toLowerCase().includes('caster')
) {
    let oldInput = productForm.querySelector(`input[name="properties[${label}]"]`);
    if (oldInput) oldInput.remove();

    const hiddenInput = document.createElement('input');
    hiddenInput.type = "hidden";
    hiddenInput.name = `properties[${label}]`;
    hiddenInput.value = value;
    productForm.appendChild(hiddenInput);
}
    });
}



document.addEventListener('click', function(event) {
    if (event.target.closest('.custom-swatch-group, .product-form__input')) {
   
        getLineItemInput();
    }
});

//custom code end

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        
              setTimeout(function(){
              updateSelectedData()
              
              },400)
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
              
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
     
                }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
             
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          if (this.pickupAvailability && typeof this.pickupAvailability.update === 'function') {
  this.pickupAvailability.update(variant);
}
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price-desk');
           updateSourceFromDestination('order-ready-btn');
            updateSourceFromDestination('grid-item--image');
          updateSourceFromDestination('button-price');
          updateSourceFromDestination('price');
         
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Sku-desk', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          mediaSlider();
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
           updateSelectedData();
           let checkbox = document.getElementById('add-premium');
            checkbox?.classList.remove('active-premium');
            
            if (checkbox) checkbox.checked = false;
           let isPremiumInput = document.getElementById('ispremium');
          if (isPremiumInput) {
          isPremiumInput.value = '';
               }
          const skuInput = document.getElementById('ContactForm-sku');
if (skuInput && variant?.sku) {
  skuInput.value = variant.sku;
}


          
          
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated) return;
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
